import Hero from "../components/home/Hero";
import AboutPreview from "../components/home/AboutPreview";

export default function Home() {
  return (
    <>
      <Hero />
      <AboutPreview />
    </>
  );
}
